import { useEffect, useRef, type RefObject } from 'react';

/** Focus an element once when the screen opens (the primary field of a form). Replaces the `autoFocus` prop. */
export function useFocusOnMount<T extends HTMLElement>(): RefObject<T | null> {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return ref;
}
